const STORAGE_KEY = 'gutschrift_data';
const SETTINGS_KEY = 'gutschrift_settings';
const RECIPIENTS_KEY = 'gutschrift_recipients';
const ARTICLES_KEY = 'gutschrift_articles';
const LAST_RECIPIENT_ID = 'last_recipient_id';
const LAST_ARTICLE_ID = 'last_article_id';

export const getStoredData = () => {
  const data = localStorage.getItem(STORAGE_KEY);
  return data ? JSON.parse(data) : [];
};

export const saveStoredData = (data) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
};

export const getSettings = () => {
  const settings = localStorage.getItem(SETTINGS_KEY);
  const defaults = {
    companyName: 'Weativ GmbH',
    address: 'Leester Str. 30\n28844 Weyhe',
    email: 'info@weativ.de',
    phone: '0421 9899 5705',
    ceo: 'Holger Brehmann',
    taxId: 'DE269590916',
    register: 'Registergericht: Walsrode',
    hrb: 'HRB 209012',
    nextNumber: 1001,
    prefix: 'GS-'
  };
  if (settings) {
    try {
      return { ...defaults, ...JSON.parse(settings) };
    } catch (e) {
      return defaults;
    }
  }
  return defaults;
};

export const saveSettings = (settings) => {
  localStorage.setItem(SETTINGS_KEY, JSON.stringify(settings));
};

// Empfänger-Logik
export const getRecipients = () => {
  const data = localStorage.getItem(RECIPIENTS_KEY);
  return data ? JSON.parse(data) : [];
};

export const saveRecipients = (recipients) => {
  localStorage.setItem(RECIPIENTS_KEY, JSON.stringify(recipients));
};

export const getLastRecipientId = () => {
  return localStorage.getItem(LAST_RECIPIENT_ID);
};

export const setLastRecipientId = (id) => {
  localStorage.setItem(LAST_RECIPIENT_ID, id);
};

// Artikel-Logik
export const getArticles = () => {
  const data = localStorage.getItem(ARTICLES_KEY);
  return data ? JSON.parse(data) : [
    { id: 'default-1', name: 'Stempelnutzung', price: 0 }
  ];
};

export const saveArticles = (articles) => {
  localStorage.setItem(ARTICLES_KEY, JSON.stringify(articles));
};

export const getLastArticleId = () => {
  return localStorage.getItem(LAST_ARTICLE_ID);
};

export const setLastArticleId = (id) => {
  localStorage.setItem(LAST_ARTICLE_ID, id);
};